import { request } from '@koi-design/vix-tools';
import { packApi } from '@/libs/tools';
import axios from 'axios';

export function sendQuestion(data) {
  return request({
    url: '/api/api-conversation/conversation/send_question/',
    method: 'post',
    data
  });
}

export function searchAnswer(data) {
  return request({
    url: '/api/api-conversation/conversation/search/answer/',
    method: 'get',
    data
  });
}

export function notifyAnswer(data) {
  return request({
    url: '/api/api-conversation/conversation/notify/answer/',
    method: 'post',
    data
  });
}

export function getHistory(data) {
  return request({
    url: '/api/api-conversation/conversation/get_history/',
    method: 'get',
    data
  });
}

export function updateLike(data) {
  return packApi({
    url: `/api/api-conversation/conversation/feedback_operation/`,
    method: 'post',
    data
  });
}
export function updateWebLike(data) {
  return packApi({
    url: `/api/api-conversation/segment_share/feedback_operation_share/`,
    method: 'post',
    data
  });
}
export function submitDislikeFeedbackShareApi(data) {
  return packApi(
    {
      url: `/api/api-conversation/segment_share/feedback_operation_share/`,
      method: 'post',
      data
    },
    'boolean',
    false
  );
}

export function removeTopApi(data) {
  return request({
    url: `/api/api-conversation/conversation/remove_top/`,
    data,
    catchAll: true,
    method: 'post'
  });
}

export function getReplyLogicApi(data) {
  return request({
    url: `/api/api-conversation/conversation/get_reply_logic/`,
    method: 'get',
    data
  });
}

export function getConversatioContextApi(data) {
  return request({
    url: `/api/api-conversation/conversation/get_conversation_context_block/`,
    method: 'get',
    data
  });
}

export const getWebChatHistoryApi = data => {
  return request({
    url: `/api/api-conversation/conversation/get_shared_web_conversation/`,
    method: 'get',
    data
  });
};

export const speechToTextApi = data => {
  return request({
    url: `/api/api-conversation/speech-to-text/`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
let questionAnswerCancelToken = null;
export const getQuestionAnswerApi = (data, id) => {
  if (questionAnswerCancelToken) {
    questionAnswerCancelToken.cancel('Operation canceled due to new request');
  }
  questionAnswerCancelToken = axios.CancelToken.source();
  return request({
    url: `/api/api-conversation/robot-stats/${id}/`,
    method: 'get',
    data,
    cancelToken: questionAnswerCancelToken.token
  });
};
export const cancelQuestionAnswerRequest = () => {
  if (questionAnswerCancelToken) {
    questionAnswerCancelToken.cancel('Request cancelled manually');
    questionAnswerCancelToken = null;
  }
};
let robotSummaryCancelToken = null;
export const getRobotSummaryApi = data => {
  if (robotSummaryCancelToken) {
    robotSummaryCancelToken.cancel('Operation canceled due to new request');
  }
  robotSummaryCancelToken = axios.CancelToken.source();
  return request({
    url: `/api/api-conversation/robot-stats-summary/`,
    method: 'get',
    data,
    cancelToken: robotSummaryCancelToken.token
  });
};
export const cancelRobotSummaryRequest = () => {
  if (robotSummaryCancelToken) {
    robotSummaryCancelToken.cancel('Request cancelled manually');
    robotSummaryCancelToken = null;
  }
};
export const getCorrectRecordsApi = data => {
  return request({
    url: `/api/api-conversation/conversation/get_conversation_correction_records/`,
    method: 'get',
    data
  });
};

export const downLoadConversationHistory = data => {
  return request({
    url: `/api/api-conversation/conversation/get_classified_conversation_v2/`,
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
};

export const getReferenceApi = (historyId, data) => {
  return request({
    url: `/api/api-conversation/conversation/${historyId}/get_reference/`,
    method: 'get',
    data
  });
};

export const getReferenceApiDebug = historyId => {
  return request({
    url: `/api/api-robot/robot/robots_tip_message_test/${historyId}/get_reference/`,
    method: 'get'
  });
};

export const getReferenceContentApi = (conversation_id, data) => {
  return request({
    url: `/api/api-conversation/conversation/${conversation_id}/get_high_light_reference/`,
    method: 'get',
    data
  });
};

export const sendEmailApi = data => {
  return request({
    url: `/api/api-conversation/conversation/notice_role_answer_conversation/`,
    method: 'get',
    data
  });
};

export const getPushDataApi = data => {
  return request({
    url: `/api/api-conversation/conversation/get_role_answer_conversation/`,
    method: 'get',
    data
  });
};

export const getConversionLabelApi = data => {
  return request({
    url: `/api/api-conversation/conversation/get_conversation_label/`,
    method: 'get',
    data
  });
};

export const addConversionLabelApi = data => {
  return packApi({
    url: `/api/api-conversation/conversation/add_conversation_label/`,
    method: 'post',
    data
  });
};

// /api/api-conversation/conversation/delete_conversation_label/
export const deleteConversionLabelApi = data => {
  return packApi({
    url: `/api/api-conversation/conversation/delete_conversation_label/`,
    method: 'get',
    data
  });
};

export const updateConversionLabelApi = data => {
  return packApi({
    url: `/api/api-conversation/conversation/modify_conversation_label/`,
    method: 'post',
    data
  });
};

export const getLastConversationIdApi = data => {
  return request({
    url: `/api/api-conversation/segment/get_last_segment_list/`,
    method: 'get',
    data
  });
};

export const testRobotApi = data => {
  return request({
    url: `/api/api-robot/robot/robots_tip_message_test/robot_chat_test/`,
    method: 'post',
    data
  });
};

export const getRobotChatHistoryApi = data => {
  return request({
    url: `/api/api-robot/robot/robots_tip_message_test/get_chat_history/`,
    method: 'get',
    data
  });
};

export const deleteRobotChatHistoryApi = data => {
  return request({
    url: `/api/api-robot/robot/robots_tip_message_test/delete_chat_history/`,
    method: 'get',
    data
  });
};

export const getRobotChatReferenceApi = data => {
  return request({
    url: `/api/api-robot/robot/robots_tip_message_test/get_robot_reply_logic/`,
    method: 'get',
    data
  });
};

export const getLastChatTimeApi = data => {
  return request({
    url: `/api/api-conversation/segment_share/get_last_chat_interval/`,
    method: 'post',
    data
  });
};

export const updateEvaluationApi = data => {
  return request({
    url: `/api/api-conversation/segment_share/update_feedback_status/`,
    method: 'post',
    data
  });
};

export const getTestReferenceApi = (id, data) => {
  return request({
    url: `/api/api-robot/robot/robots_tip_message_test/${id}/get_high_light_reference/`,
    method: 'get',
    data
  });
};

export const adminFeedbackApi = data => {
  return packApi({
    url: `/api/api-conversation/segment/update_admin_feedback_status/`,
    method: 'post',
    data
  });
};

let robotUseTimeCancelToken = null;
export const getRobotUseTimeApi = data => {
  if (robotUseTimeCancelToken) {
    robotUseTimeCancelToken.cancel('Operation canceled due to new request');
  }
  robotUseTimeCancelToken = axios.CancelToken.source();
  return request({
    url: '/api/api-conversation/conversation/get_robot_use_time_v2/',
    method: 'get',
    data,
    cancelToken: robotUseTimeCancelToken.token
  });
};

export const cancelRobotUseTimeRequest = () => {
  if (robotUseTimeCancelToken) {
    robotUseTimeCancelToken.cancel('Request cancelled manually');
    robotUseTimeCancelToken = null;
  }
};
export const downloadWordApi = data => {
  return request({
    url: '/api/api-conversation/conversation/get_history_to_docx/',
    method: 'post',
    data
  });
};

export const generateSuggestionShareApi = data => {
  return request({
    url: `/api/api-conversation/suggestion/generate_smart_suggestion/`,
    method: 'post',
    data
  });
};
export const generateSuggestionApi = data => {
  return request({
    url: `/api/api-conversation/suggestion/generate_smart_suggestion_v2/`,
    method: 'post',
    data
  });
};

export const deleteFilesApi = data => {
  return request({
    url: '/api/api-chatflow/chatflow/delete_files/',
    method: 'post',
    data
  });
};

// Trigger end conversation with new segment code
export const triggerEndApi = data => {
  return request({
    url: `/api/api-conversation/conversation/trigger_end/`,
    method: 'post',
    data
  });
};

export const downloadAnswerApi = data => {
  return request({
    url: '/api/api-conversation/conversation-history/info/',
    method: 'get',
    data
  });
};

export const downloadTaskFlowAgentOutputApi = (data, url) => {
  return request({
    url,
    method: 'get',
    data
  });
};

// OpenAPI: Trigger end conversation on share page
export const triggerEndOpenApi = data => {
  return request({
    url: `/openapi/v1/conversation/trigger_end/`,
    method: 'post',
    data
  });
};

export const saveTempFileApi = data => {
  return request({
    url: `/api/app/cybertron/save_temp_file/`,
    method: 'post',
    data
  });
};

export const downloadAnswerOpenApi = data => {
  return request({
    url: '/api/openapi/v1/conversation/history_download/',
    method: 'post',
    data
  });
};
export const downloadAnswerStreamApi = data => {
  return request({
    url: '/openapi/v1/conversation/history_download_stream/',
    method: 'post',
    data,
    catchAll: true,
    responseType: 'blob'
  });
};
export const getJumpToWhiteListApi = data => {
  return request({
    url: '/api/api-config/web_url_white_list/',
    method: 'get',
    data
  });
};

export const getReferenceChunkApi = (referenceId, data) => {
  return request({
    url: `/api/api-chatflow/long-text/${referenceId}/chunks/`,
    method: 'get',
    data
  });
};

export const downloadLongTextApi = (referenceId, data) => {
  return request({
    url: `/api/api-chatflow/long-text/${referenceId}/download/`,
    method: 'get',
    data,
    responseType: 'blob',
    catchAll: true
  });
};
